module.exports = __webpack_public_path__ + "static/media/location.b69ce446.png";